var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('newsletter-component',{attrs:{"documents-name":"Newsletters","documents":_vm.newsletters}})}
var staticRenderFns = []

export { render, staticRenderFns }